// @flow
import React from 'react';
import { I18n } from '@lingui/react';
import styled, { type StyledComponent } from 'styled-components';

import allCountries from '@rover/react-lib/constants/countries.constants.json';

import { MQ } from '@rover/kibble/styles';

import SelectInput, { type Props as SelectInputProps } from '../../formFields/Select';

type Props = {
  ...SelectInputProps<string>,
  supportedCountryCodes: ?Array<string>,
  onChange: string => void,
};

const StyledSelectInput: StyledComponent<React$ElementConfig<typeof SelectInput>, {}, any> = styled(
  SelectInput
)`
  flex: 2;

  ${MQ.XS} {
    margin-right: 0;
  }
`;

const mapCountriesToOptions = countries =>
  countries.map(({ name, code }) => ({
    title: name,
    value: code,
  }));

const getCountryOptions = supportedCountryCodes => {
  if (!supportedCountryCodes || supportedCountryCodes.length === 0) {
    return mapCountriesToOptions(allCountries);
  }

  const supportedCountryList = allCountries
    .filter(country => supportedCountryCodes.includes(country.code))
    // Maintain the same country order as supportedCountryCodes
    .sort((a, b) => supportedCountryCodes.indexOf(a.code) - supportedCountryCodes.indexOf(b.code));

  const otherCountryList = allCountries.filter(
    country => !supportedCountryCodes.includes(country.code)
  );

  return [
    ...mapCountriesToOptions(supportedCountryList),
    { title: '------', value: '', disabled: true },
    ...mapCountriesToOptions(otherCountryList),
  ];
};

const AddressFormCountryField = ({ supportedCountryCodes, onChange, ...other }: Props) => (
  <I18n>
    {({ i18n }) => (
      <StyledSelectInput
        label={i18n._('Country')}
        name="country"
        data-qa-id="input-text-address-country"
        options={getCountryOptions(supportedCountryCodes)}
        onChange={value => onChange(value.toString())}
        {...other}
      />
    )}
  </I18n>
);

export default AddressFormCountryField;



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/AddressForm/AddressFormCountryField.jsx